app.factory('Socket', ['$rootScope', function ($rootScope) {
    var connection;

    function getConnection() {
        if (!connection) {
            connection = io.connect();
        }
        return connection;
    }

    function Socket() {
        getConnection();
    }

    Socket.prototype.on = function (eventName, callback) {
        var con = getConnection(this.namespace);
        con.on(eventName, function () {
            var args = arguments;
            $rootScope.$apply(function () {
                callback.apply(con, args);
            });
        });
    };

    Socket.prototype.emit = function (eventName, data, callback) {
        var con = getConnection(this.namespace);
        con.emit(eventName, data, function () {
            var args = arguments;
            $rootScope.$apply(function () {
                if (callback) {
                    callback.apply(con, args);
                }
            });
        })
    };

    return Socket;
}]);